import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Ellipsis } from 'react-spinners-css'

type SpinnerEllipsisProps = {
  color?: string
  showText?: boolean
  text?: string
  size?: number
}

const SpinnerEllipsis = ({
  color = '#666',
  showText = false,
  text = '',
  size = 50
}: SpinnerEllipsisProps): JSX.Element => {
  return (
    <React.Fragment>
      <Row>
        <Col className='text-center'>
          <Ellipsis color={color} size={size}></Ellipsis>
          {showText ? <h3>{text}</h3> : null}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default SpinnerEllipsis
